import {css, StyleSheet} from "aphrodite";
import * as React from "react";

import {mediaQueries} from "@repo/shared-styles";
import {staticUrl} from "@repo/urls";

import {markAppDownload} from "../lib/analytics.ts";

type Props = {
    /**
     * URL for the store badge image. Will be used as argument for `staticUrl`.
     */
    imageUrl: string;
    /**
     * A name by which to identify the store that provides the app.
     * Used for conversions.
     */
    storeName: string;
    /**
     * Safe URL that directs to the store page for downloading the app.
     */
    safeStoreUrl: string;
    /**
     * I18nized accessible text for the badge.
     */
    altText: string;
};

export default class AppBadge extends React.Component<Props> {
    markConversion: () => Promise<Response | null | undefined> = () =>
        markAppDownload(this.props.storeName);

    render(): React.ReactNode {
        const {imageUrl, safeStoreUrl, altText} = this.props;
        return (
            <a
                className={css(styles.appStoreLink)}
                href={safeStoreUrl}
                aria-label={altText}
                onClick={this.markConversion}
            >
                <img
                    className={css(styles.badgeImage)}
                    src={staticUrl(imageUrl)}
                    alt=""
                    aria-hidden={true}
                />
            </a>
        );
    }
}

const styles = StyleSheet.create({
    appStoreLink: {
        position: "relative",
        display: "inline-block",
        marginRight: 10,
        height: 38,

        [mediaQueries.mdOrSmaller]: {
            marginRight: 0,
            marginTop: 20,
            height: 77,
        },

        [mediaQueries.smOrSmaller]: {
            marginRight: 0,
            marginTop: 16,
            height: 60,
        },
    },

    badgeImage: {
        height: "100%",
    },
});
